import { Grid } from "@material-ui/core";
import { DestinatariosModel } from "model/api/gestao/destinatarios/destinatarios-model";
import { CardDestinatario } from "views/components/cards/card-destinatarios/card-destinatario";
import { CardNaoEncontrado } from "views/components/cards";
import { InformacaoIcon } from "views/components/icons";

export interface PropagandaRespostasPendentesDataProps {
  list: Array<DestinatariosModel>;
  carregando: boolean;
  onCardSelected: (id: string) => any;
  onCardChecked: (model: DestinatariosModel) => any;
  onCardRemove: (id: string) => void;
  isPendente: boolean
  selecionados: Array<string>
  isSelectMode: boolean
}

export const PropagandaRespostaData = (props: PropagandaRespostasPendentesDataProps) => {

  const onCardSelected = (id: string) => {
    props.onCardSelected(id);
  };

  const onCardChecked = (model: DestinatariosModel) => {
    props.onCardChecked(model)
  };

  return (
    <>

      {props.list.length === 0 && !props.carregando && (
        <CardNaoEncontrado
          mensagem="Nenhuma Resposta Encontrada."
          icon={<InformacaoIcon tipo="GERAL" />}
        />
      )}

      {props.list.map((resposta) => {
        return (
          <Grid item xs={12} key={resposta.id}>
            <CardDestinatario
              selected={props.selecionados.includes(resposta.id)}
              isSelectMode={props.isSelectMode}
              isPendente={props.isPendente}
              model={resposta}
              onClick={onCardSelected}
              onCheck={onCardChecked}
              onClickRemove={props.onCardRemove}
            />
          </Grid>
        );
      })}
    </>
  );
};